import React from 'react';
import { connect } from 'react-redux';
import { FixedActionBar } from '@beef/landing-constructor';
import { withRenderFlag } from '@beef/react';
import { compose } from '@beef/redux';
import { isEmpty } from 'lodash';
import { BackCallPopup } from '@fttb/common/components';
import { getCaptchaFlag } from '@fttb/common/store';
import { handleClickWithAnalytics, handleFillPhoneInput, handleFocusInput, handleSubmitCallbackRequest, onActionBarClickAnalytics } from "../../store/actionBarWithBackCall/actions";
import { getActionBar, getActionBarButton, getActionBarSubTitle, getActionBarTitle } from "../../store/actionBarWithBackCall/selectors";
import { selectCommonData } from "../OrderTariffFormPopup/OrderTariffFormOldPopup/store/selectors/orderTariffCommon";
import { getIsConvergent } from "../../store/blocks/selectors";
import { getIsActionBarOpen } from "../../store/selectors";
import { selectIsFttbPersonalVerificationCheckboxEnable } from "../../store/callbackRequest/selectors";
import { TitleWithAnalytic } from "./components/Title";
var _ActionBarWithBackCall = function _ActionBarWithBackCall(_ref) {
  var button = _ref.button,
    callbackRequestData = _ref.callbackRequestData,
    isConvergent = _ref.isConvergent,
    isOpen = _ref.isOpen,
    onClick = _ref.onClick,
    showCaptcha = _ref.showCaptcha,
    subTitle = _ref.subTitle,
    onButtonClick = _ref.onButtonClick,
    handlePhoneInputFocus = _ref.handlePhoneInputFocus,
    handleChange = _ref.handleChange,
    handleSubmit = _ref.handleSubmit,
    isPersonalVerificationCheckboxEnable = _ref.isPersonalVerificationCheckboxEnable;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FixedActionBar, {
    button: button,
    onClick: onButtonClick,
    subTitle: subTitle,
    title: /*#__PURE__*/React.createElement(TitleWithAnalytic, null),
    withoutHidden: true,
    "data-t-id": "components-ActionBarWithBackCall"
  }), isOpen && /*#__PURE__*/React.createElement(BackCallPopup, {
    analyticsOnChange: handleChange,
    analyticsOnFocus: handlePhoneInputFocus,
    analyticsOnSubmit: handleSubmit,
    data: callbackRequestData,
    isConvergent: isConvergent,
    isIcon: true,
    isOpen: true,
    isPersonalVerificationCheckboxEnable: isPersonalVerificationCheckboxEnable,
    onClose: onClick,
    redesign: true,
    showCaptcha: showCaptcha
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    button: getActionBarButton(state),
    callbackRequestData: selectCommonData(state),
    isConvergent: getIsConvergent(state),
    isOpen: getIsActionBarOpen(state),
    shouldRender: !isEmpty(getActionBar(state)),
    showCaptcha: getCaptchaFlag(state),
    subTitle: getActionBarSubTitle(state),
    title: getActionBarTitle(state),
    isPersonalVerificationCheckboxEnable: selectIsFttbPersonalVerificationCheckboxEnable(state)
  };
};
var mapDispatchToProps = {
  onClick: onActionBarClickAnalytics,
  handlePhoneInputFocus: handleFocusInput,
  handleChange: handleFillPhoneInput,
  handleSubmit: handleSubmitCallbackRequest,
  onButtonClick: handleClickWithAnalytics
};
var connector = connect(mapStateToProps, mapDispatchToProps);
export var ActionBarWithBackCall = compose(connector, withRenderFlag)(_ActionBarWithBackCall);